import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Buscador de módulos del menú lateral: filtra por nombre y descripción (sin
// importar tildes), abre los grupos que coinciden, Enter entra al primero y Esc limpia.

const clave = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

export function useFiltroMenu(menuGroups) {
  const [filtro, setFiltro] = useState('')
  const grupos = useMemo(() => {
    const q = clave(filtro.trim())
    if (!q) return menuGroups
    return menuGroups
      .map((g) => ({ ...g, items: g.items.filter((i) => clave(`${i.name} ${i.tooltip || ''} ${g.label}`).includes(q)) }))
      .filter((g) => g.items.length)
  }, [menuGroups, filtro])
  return { filtro, setFiltro, grupos, buscando: !!filtro.trim() }
}

export function BuscadorMenu({ filtro, setFiltro, grupos, onElegir }) {
  const navigate = useNavigate()
  const primero = grupos[0]?.items[0]

  const elegir = () => {
    if (!primero) return
    if (primero.external) window.open(primero.href, '_blank', 'noopener,noreferrer')
    else navigate(primero.href)
    setFiltro('')
    onElegir?.()
  }

  return (
    <div className="mx-4 mb-2">
      <div className="relative">
        <svg className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-white/60" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z" />
        </svg>
        <input
          type="search" value={filtro} onChange={(e) => setFiltro(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') { e.preventDefault(); elegir() }
            if (e.key === 'Escape') setFiltro('')
          }}
          placeholder="Buscar módulo…" aria-label="Buscar un módulo del menú"
          className="w-full rounded-xl border border-white/15 bg-white/10 py-2 pl-9 pr-3 text-sm font-semibold text-white placeholder-white/55 outline-none transition focus:border-white/40 focus:bg-white/15"
        />
      </div>
      {filtro.trim() && (
        <p className="mt-1.5 px-1 text-[11px] font-semibold text-white/60">
          {primero ? `${grupos.reduce((a, g) => a + g.items.length, 0)} resultado(s) · Enter abre "${primero.name}"` : 'Ningún módulo coincide'}
        </p>
      )}
    </div>
  )
}
